import cookie from 'js-cookie'

export default class Cookie {
  constructor() {
    this.cookie = cookie
  }
}
